import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e5f30d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hop-dong-meta-step" }
const _hoisted_2 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_3 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_4 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_5 = { class: "d-flex align-items-center gap-3 w-100" }
const _hoisted_6 = { class: "d-flex flex-column align-items-start flex-shrink-0" }
const _hoisted_7 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_8 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted mt-1" }, " Dữ liệu Tài khoản từ hệ thống tài khoản kế toán. Tìm kiếm để có thông tin đồng bộ với kế toán ", -1))
const _hoisted_10 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_11 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_12 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_13 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_14 = { class: "d-flex flex-column align-items-start w-100" }

import LabelCustom from "@/components/shared/label-custom/LabelCustom.vue";
import TaiKhoanSelectionV2 from "@/components/shared/tai-khoan-selection/TaiKhoanSelectionV2.vue";
import { formatContractNumber } from "@/core/helpers/utils";
import type {
  AccountantItemResponse,
  IBienBanResponseBase,
  ITaiKhoanKeToanResponse,
} from "@/core/interfaces/ApiResponses";
import DivCol from "@/layout/_shared/DivCol.vue";
import DivRow from "@/layout/_shared/DivRow.vue";

export interface HopDongMetaContractModel {
  bien_ban_kiem_nghiem: IBienBanResponseBase[];
  contractNumber: string;
  signDate: string;
  expiryDate: string;
  partnerName: string;
  phoneNumber: string;
  address: string;
  taxNumber: string;
  loai_hop_dong: number;
  so_hoa_don: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HopDongMetaStep',
  props: {
    contract: {},
    isNoExpiration: { type: Boolean },
    taiKhoanData: {},
    loaiHopDongOptions: {}
  },
  emits: ["update:contract", "update:isNoExpiration", "select-tai-khoan", "toggle-no-expiration", "focus-contract-number", "focus-sign-date", "focus-expiry-date", "focus-loai-hop-dong", "focus-so-hoa-don", "focus-tax-number", "focus-partner-name", "focus-phone-number", "focus-address", "set-ref"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DivRow, { class: "mb-3 g-3" }, {
      default: _withCtx(() => [
        _createVNode(DivCol, {
          "additional-class": "pb-4",
          cols: 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(LabelCustom, {
                "is-required": true,
                class: "hop-dong-form-label-clickable",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('focus-contract-number')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Số hợp đồng")
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "contractNumber",
                class: "mb-0 w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    ref: (el) => _ctx.$emit('set-ref', 'contractNumber', el),
                    "model-value": _ctx.contract.contractNumber,
                    class: "contract-number-input",
                    placeholder: "Nhập số hợp đồng",
                    name: "contractNumber",
                    maxlength: "20",
                    "show-word-limit": "",
                    onFocus: _cache[1] || (_cache[1] = ($event: any) => (($event.target as HTMLInputElement).select())),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = 
                (val) =>
                  _ctx.$emit('update:contract', {
                    contractNumber: _unref(formatContractNumber)(val),
                  })
              )
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(DivCol, {
          "additional-class": "pb-4",
          cols: 2
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(LabelCustom, {
                "is-required": true,
                class: "hop-dong-form-label-clickable",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('focus-sign-date')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Ngày ký")
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "signDate",
                class: "mb-0 w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    ref: (el) => _ctx.$emit('set-ref', 'signDate', el),
                    "model-value": _ctx.contract.signDate,
                    "allow-before-global-min": "",
                    class: "w-100",
                    placeholder: "Chọn ngày",
                    name: "signDate",
                    format: "DD/MM/YYYY",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = 
                (val) => _ctx.$emit('update:contract', { signDate: val })
              )
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(DivCol, {
          "additional-class": "pb-4",
          cols: 4
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(LabelCustom, {
                class: "hop-dong-form-label-clickable",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('focus-expiry-date')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Ngày hết hạn")
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_form_item, {
                  prop: "expiryDate",
                  class: "mb-0 flex-grow-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      ref: (el) => _ctx.$emit('set-ref', 'expiryDate', el),
                      "model-value": _ctx.contract.expiryDate,
                      class: "w-100",
                      placeholder: "Chọn ngày",
                      name: "expiryDate",
                      format: "DD/MM/YYYY",
                      disabled: _ctx.isNoExpiration,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = 
                  (val) => _ctx.$emit('update:contract', { expiryDate: val })
                )
                    }, null, 8, ["model-value", "disabled"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(LabelCustom, {
                    class: "hop-dong-form-label-clickable",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('toggle-no-expiration')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Vô thời hạn")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, {
                    "model-value": _ctx.isNoExpiration,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = 
                  (val) => _ctx.$emit('update:isNoExpiration', Boolean(val))
                )
                  }, null, 8, ["model-value"])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(DivCol, {
          "additional-class": "pb-4",
          cols: 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(LabelCustom, {
                "is-required": true,
                class: "hop-dong-form-label-clickable",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('focus-loai-hop-dong')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Loại Hợp đồng")
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "loai_hop_dong",
                class: "mb-0 w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    ref: (el) => _ctx.$emit('set-ref', 'loaiHopDong', el),
                    "model-value": _ctx.contract.loai_hop_dong,
                    disabled: _ctx.contract.bien_ban_kiem_nghiem.length > 0,
                    class: "w-100",
                    name: "loai_hop_dong",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = 
                (val) => _ctx.$emit('update:contract', { loai_hop_dong: val })
              )
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loaiHopDongOptions, (type) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: type.value,
                          label: type.label,
                          value: type.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["model-value", "disabled"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(DivRow, { class: "mb-3 g-3" }, {
      default: _withCtx(() => [
        _createVNode(DivCol, {
          "additional-class": "pb-4",
          cols: 9
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(LabelCustom, null, {
                default: _withCtx(() => [
                  _createTextVNode("Tài khoản")
                ]),
                _: 1
              }),
              _createVNode(TaiKhoanSelectionV2, {
                class: "w-100",
                "ma-tai-khoan-prop": 
              _ctx.taiKhoanData.matk ? parseInt(_ctx.taiKhoanData.matk) : undefined
            ,
                "ma-chi-tiet-prop": _ctx.taiKhoanData.mact || undefined,
                "ten-tai-khoan-prop": _ctx.taiKhoanData.tentk,
                onOnSelect: _cache[11] || (_cache[11] = (payload) => _ctx.$emit('select-tai-khoan', payload))
              }, null, 8, ["ma-tai-khoan-prop", "ma-chi-tiet-prop", "ten-tai-khoan-prop"]),
              _hoisted_9
            ])
          ]),
          _: 1
        }),
        _createVNode(DivCol, {
          "additional-class": "pb-4",
          cols: 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(LabelCustom, {
                class: "hop-dong-form-label-clickable",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('focus-so-hoa-don')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Số hoá đơn")
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "so_hoa_don",
                class: "mb-0 w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    ref: (el) => _ctx.$emit('set-ref', 'soHoaDon', el),
                    "model-value": _ctx.contract.so_hoa_don,
                    name: "so_hoa_don",
                    onFocus: _cache[13] || (_cache[13] = ($event: any) => (($event.target as HTMLInputElement).select())),
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = 
                (val) => _ctx.$emit('update:contract', { so_hoa_don: val })
              )
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(DivRow, { class: "mb-3 g-3" }, {
      default: _withCtx(() => [
        _createVNode(DivCol, {
          "additional-class": "pb-4",
          cols: 2
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(LabelCustom, {
                "is-required": true,
                class: "hop-dong-form-label-clickable",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('focus-tax-number')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Mã số thuế")
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "taxNumber",
                class: "mb-0 w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    ref: (el) => _ctx.$emit('set-ref', 'taxNumber', el),
                    "model-value": _ctx.contract.taxNumber,
                    placeholder: "Nhập mã số thuế",
                    name: "taxNumber",
                    onFocus: _cache[16] || (_cache[16] = ($event: any) => (($event.target as HTMLInputElement).select())),
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = 
                (val) => _ctx.$emit('update:contract', { taxNumber: val })
              )
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(DivCol, {
          "additional-class": "pb-4",
          cols: 4
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(LabelCustom, {
                "is-required": true,
                class: "hop-dong-form-label-clickable",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('focus-partner-name')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Tên đối tác")
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "partnerName",
                class: "mb-0 w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    ref: (el) => _ctx.$emit('set-ref', 'partnerName', el),
                    "model-value": _ctx.contract.partnerName,
                    placeholder: "Nhập tên",
                    name: "partnerName",
                    onFocus: _cache[19] || (_cache[19] = ($event: any) => (($event.target as HTMLInputElement).select())),
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = 
                (val) => _ctx.$emit('update:contract', { partnerName: val })
              )
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(DivCol, {
          "additional-class": "pb-4",
          cols: 2
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(LabelCustom, {
                class: "hop-dong-form-label-clickable",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('focus-phone-number')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Số điện thoại")
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "phoneNumber",
                class: "mb-0 w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    ref: (el) => _ctx.$emit('set-ref', 'phoneNumber', el),
                    "model-value": _ctx.contract.phoneNumber,
                    placeholder: "VD: +84 901-234-567, (028) 1234-5678",
                    name: "phoneNumber",
                    onFocus: _cache[22] || (_cache[22] = ($event: any) => (($event.target as HTMLInputElement).select())),
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = 
                (val) => _ctx.$emit('update:contract', { phoneNumber: val })
              )
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(DivCol, {
          "additional-class": "pb-4",
          cols: 4
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(LabelCustom, {
                class: "hop-dong-form-label-clickable",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.$emit('focus-address')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Địa chỉ")
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "address",
                class: "mb-0 w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    ref: (el) => _ctx.$emit('set-ref', 'address', el),
                    "model-value": _ctx.contract.address,
                    placeholder: "Địa chỉ",
                    name: "address",
                    onFocus: _cache[25] || (_cache[25] = ($event: any) => (($event.target as HTMLInputElement).select())),
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = 
                (val) => _ctx.$emit('update:contract', { address: val })
              )
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})